import { render, staticRenderFns } from "./TelegramModal.vue?vue&type=template&id=57856b34"
import script from "./TelegramModal.vue?vue&type=script&lang=js"
export * from "./TelegramModal.vue?vue&type=script&lang=js"
import style0 from "./TelegramModal.vue?vue&type=style&index=0&id=57856b34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports